import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {map} from 'rxjs/operators'

@Injectable({
    providedIn: 'root'
})

export class MessagesState {
    allMessages = new BehaviorSubject<any>(null);
    messagesCompactView = new BehaviorSubject<any>(null);
    currentMessage = new BehaviorSubject<any>(null);
    messagesCount = new BehaviorSubject<any>(null);
    currentPage = new BehaviorSubject<number>(1);

    constructor() { }

    setAllMessages(messages:any){  // list  view
        if(this.allMessages.getValue()){
            const messages2 = [...this.allMessages.getValue(), ...messages]
            this.allMessages.next(messages2)
        }
        else{
            this.allMessages.next(messages)
        }
    }
    getMessages$(){ // list view
        return this.allMessages.asObservable();
    }
    setCurrentMessage(message){ //list view
        this.currentMessage.next(message)
    }
    getCurrentMessage$(){ //list view
        return this.currentMessage.asObservable();
    }

    setMessagesCompactView(messages){
        this.messagesCompactView.next(messages)
    }
    
    getMessagesCompactView$(){
        return this.messagesCompactView.asObservable();
    }
    setMessagesCount(messagesCount: number){
        this.messagesCount.next(messagesCount)
    }
    getMessageCoun$(){
        return this.messagesCount.asObservable();
    }
    setCurrentPage(){
      this.currentPage.next( this.currentPage.getValue() + 1 );  
    }
    getCurrentPage$(){
        return this.currentPage.asObservable();
    }
    
    

}